import { useEffect } from "react"
import { useBaseMap } from "../BaseMap"
import { HereGeocodePosition } from "../../../models/MapModels"
import { formatMiles, isRealPosition, milesBetween } from "../mapUtils"

interface IProps {
    from?: HereGeocodePosition
    to?: HereGeocodePosition
    /** Written on the line; the straight-line miles when left out. */
    label?: string
    color?: string
}

/** A dashed line between two points with the distance on it -- e.g. a job and the technician picked for it. */
export default function DistanceLineLayer(props: IProps) {

    const { L, map } = useBaseMap()
    const fromKey = `${props.from?.lat},${props.from?.lng}`
    const toKey = `${props.to?.lat},${props.to?.lng}`

    useEffect(() => {
        if (!isRealPosition(props.from) || !isRealPosition(props.to)) return

        const miles = milesBetween(props.from, props.to)
        const label = props.label ?? (miles != null ? formatMiles(miles) : undefined)

        const line = L.polyline([[props.from.lat, props.from.lng], [props.to.lat, props.to.lng]], {
            color: props.color ?? "#1b84ff",
            weight: 3,
            opacity: .85,
            dashArray: "6 8",
            interactive: false
        }).addTo(map)

        if (label) line.bindTooltip(label, { permanent: true, direction: "center", className: "base-map-distance-label" }).openTooltip()

        return () => { line.remove() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map, fromKey, toKey, props.label, props.color])

    return null
}
